<template>
    <div class="white-bg clearfix">
        <div class="flex-container">
            <div class="flex-left">
                <vButton
                    class="margin-btn"
                    theme="success"
                    @click="operate('add')"
                    >{{
                        $t("boss.purchase.add", { defaultValue: "新增" })
                    }}</vButton
                >
                <vButton
                    class="margin-btn"
                    theme="primary"
                    @click="operate('export')"
                    >{{
                        $t("boss.purchase.export_query_conditions", {
                            defaultValue: "查询条件导出",
                        })
                    }}</vButton
                >
                <Dropdown class="margin-btn" trigger="click">
                    <vButton>
                        <div style="padding-right: 5px">
                            {{
                                $t("boss.purchase.operate", {
                                    defaultValue: "操作",
                                })
                            }}
                        </div>
                        <Icon type="arrow-down-b"></Icon>
                    </vButton>
                    <DropdownMenu slot="list">
                        <DropdownItem @click="operate('import')">{{
                            $t("boss.purchase.batch_import", {
                                defaultValue: "批量导入",
                            })
                        }}</DropdownItem>
                        <DropdownItem @click="operate('lossEff')">{{
                            $t("boss.purchase.batch_invalidation", {
                                defaultValue: "批量失效",
                            })
                        }}</DropdownItem>
                        <DropdownItem @click="operate('active')">{{
                            $t("boss.purchase.batch_activation", {
                                defaultValue: "批量启用",
                            })
                        }}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div class="flex-middle">
                <Form inline style="text-align: right" :labelWidth="70">
                    <FormItem
                        label="ERP SKU"
                        :props="formData.search.EQ_erpsku"
                        :labelWidth="70"
                        style="width: 330px"
                    >
                        <vInput v-model="formData.search.EQ_erpsku"></vInput>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('boss.purchase.currency', {
                                defaultValue: '币种',
                            })
                        "
                        :props="formData.search.IN_currency"
                        :labelWidth="70"
                        style="width: 330px"
                    >
                        <vInput v-model="formData.search.IN_currency"></vInput>
                    </FormItem>
                </Form>
            </div>
            <div class="flex-right">
                <Form inline>
                    <Button
                        class="margin-btn"
                        type="primary"
                        @click="operate(true)"
                        icon="ios-search-strong"
                        >{{
                            $t("global.common.btn_search", {
                                defaultValue: "查询",
                            })
                        }}</Button
                    >
                    <Button
                        class="margin-btn"
                        @click="resetdata"
                        icon="refresh"
                        >{{
                            $t("global.common.btn_reset", {
                                defaultValue: "重置",
                            })
                        }}</Button
                    >
                    <Button
                        class="margin-btn"
                        type="dashed"
                        @click="isOpen = !isOpen"
                        >{{
                            $t("global.common.btn_more", {
                                defaultValue: "更多查询",
                            })
                        }}<Icon type="chevron-down" class="margin-left-5"></Icon
                    ></Button>
                </Form>
            </div>
        </div>
        <transition name="slide-both">
            <div v-show="isOpen">
                <Form class="search-other" :labelWidth="110" inline>
                    <FormItem
                        :label="
                            $t('boss.purchase.supplier_name', {
                                defaultValue: '供应商名称',
                            })
                        "
                        :props="formData.search.EQ_supplierId"
                        style="width: 330px"
                    >
                        <vInput
                            v-model="formData.search.EQ_supplierId"
                        ></vInput>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('boss.purchase.project', {
                                defaultValue: '项目',
                            })
                        "
                        :props="formData.search.IN_lineId"
                        style="width: 330px"
                    >
                        <vInput v-model="formData.search.IN_lineId"></vInput>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('boss.purchase.production_cycle', {
                                defaultValue: '生产周期',
                            })
                        "
                        :props="formData.search.IN_lineId"
                        style="width: 330px"
                    >
                        <InputNumber
                            v-model="formData.search.GE_cycle"
                            style="width: 100px"
                        ></InputNumber>
                        ~
                        <InputNumber
                            v-model="formData.search.LE_cycle"
                            style="width: 100px"
                        ></InputNumber>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('boss.purchase.purchase_unit_price', {
                                defaultValue: '采购单价',
                            })
                        "
                        :props="formData.search.IN_lineId"
                        style="width: 330px"
                    >
                        <InputNumber
                            v-model="formData.search.GE_price"
                            style="width: 100px"
                        ></InputNumber>
                        ~
                        <InputNumber
                            v-model="formData.search.LE_price"
                            style="width: 100px"
                        ></InputNumber>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('boss.purchase.created_at', {
                                defaultValue: '创建时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 220px"
                            format="yyyy-mm-dd ~ yyyy-mm-dd"
                            :value="formData.search.BT_createAt"
                            @on-change="handleChange"
                        ></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
            formData: {
                search: {},
            },
        };
    },
    methods: {
        handleChange(data) {
            this.formData.search.GE_createdAt = date[0];
            this.formData.search.LE_createdAt = date[1];
        },
        operate(type) {
            this.$emit("query", this.formData.search);
            this.$emit("on-update", this.formData);
        },
        resetdata() {
            this.formData = {};
            this.$emit("update", { search: this.formData, page: 1 });
        },
    },
};
</script>

<style lang="scss" scoped>
.white-bg {
    background-color: #fff;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;

    .flex-container {
        display: flex;
        justify-content: space-between;

        .flex-middle {
            padding-left: 20px;
            flex: 1;
        }
    }

    .margin-btn {
        margin-right: 5px;
        margin-bottom: 15px;
    }
}
</style>
